import React, { useEffect, useState } from "react";
import { api, API } from "../lib/api";
import { useI18n } from "../context/I18nContext";
import { useParams, Link } from "react-router-dom";
import { Button } from "../components/ui/button";
import { ArrowLeft, Download } from "lucide-react";

export default function ReportViewer() {
  const { reportId } = useParams();
  const { lang } = useI18n();
  const [rep, setRep] = useState(null);
  const [err, setErr] = useState(null);

  useEffect(() => {
    api.get(`/reports/${reportId}`)
      .then((r) => setRep(r.data))
      .catch((e) => setErr(e?.response?.data?.detail || "Erreur"));
  }, [reportId]);

  if (err) {
    return <div className="section"><div className="container-page text-slate-500">{err}</div></div>;
  }
  if (!rep) {
    return <div className="section"><div className="container-page text-slate-500">Chargement…</div></div>;
  }

  return (
    <div className="max-w-5xl mx-auto px-6 lg:px-10 py-10">
      <div className="flex items-center justify-between flex-wrap gap-4">
        <Button asChild variant="outline" size="sm" className="rounded-sm" data-testid="report-back">
          <Link to="/dashboard/reports"><ArrowLeft className="h-3.5 w-3.5 mr-2" /> {lang === "fr" ? "Tous les reportings" : "All reports"}</Link>
        </Button>
        <a
          href={`${API}/reports/${rep.report_id}/pdf`}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center justify-center text-sm h-9 px-4 bg-slate-900 hover:bg-slate-800 text-white rounded-sm"
          data-testid="report-download-pdf"
        >
          <Download className="h-4 w-4 mr-2" /> {lang === "fr" ? "Télécharger le PDF" : "Download PDF"}
        </a>
      </div>

      <article
        className="mt-8 bg-white border border-slate-200 rounded-sm p-10"
        data-testid="report-html"
        dangerouslySetInnerHTML={{ __html: rep.html }}
      />
    </div>
  );
}
